"use client";

import type { BlockBase } from "@/cms/blocks/registry/types";

export const ALL_BLOCK_OPTIONS: Array<{ type: BlockBase["type"]; label: string }> = [
  { type: "contact", label: "Contact" },
  { type: "heading", label: "Heading" },
  { type: "paragraph", label: "Paragraph" },
  { type: "image", label: "Image" },
  { type: "divider", label: "Divider" },
  { type: "list", label: "List" },
  { type: "faq", label: "FAQ" },
  { type: "quote", label: "Quote" },
  { type: "link", label: "Link" },
  { type: "embed", label: "Embed" },
  { type: "contentReference", label: "Content Reference" },
  { type: "reference", label: "Reference" },
  { type: "productCard", label: "Product Card" },
  { type: "table", label: "Table" },
];
